import {
  CameraLabels,
  getSituationColorClasses,
  normalizeSchedules,
  renderSubItems,
  ScheduleLabels,
} from '@hakimo-ui/hakimo/feature-shared';
import { Situation } from '@hakimo-ui/hakimo/types';
import { useState } from 'react';

interface Props {
  situation: Situation;
}

export function SituationChip({ situation }: Props) {
  const [expanded, setExpanded] = useState(false);
  const { label, color, subSituations, cameras } = situation;

  return (
    <div className={getSituationColorClasses(color)}>
      <div className="flex items-center">
        <span className="font-medium">{label}</span>
      </div>
      {subSituations &&
        subSituations.length > 0 &&
        renderSubItems(subSituations, expanded, () =>
          setExpanded((prev) => !prev)
        )}
      <ScheduleLabels
        schedules={normalizeSchedules(situation)}
        className="mt-1"
      />
      {cameras && cameras.length > 0 && (
        <div className="mt-2">
          <CameraLabels cameras={cameras} />
        </div>
      )}
    </div>
  );
}

export default SituationChip;
